export const RESOURCE_SELECTOR_BLOCK_ID = "p0_resource_block";
export const ACCESS_TYPE_BLOCK_ID = "p0_access_type_block";

export const RELINQUISH_ACTION_ID = "p0_requestor_notification_relinquish";
export const ESCALATE_ACTION_ID = "p0_requestor_notification_escalate";
export const REQUEST_AGAIN_ACTION_ID =
  "p0_requestor_notification_request_again";

export const START_REQUEST_ACTION_ID = "p0_start_request";
export const REQUEST_MODAL_INPUT_ACTION_ID = "p0_request_modal_input";
export const ALLOW_MODAL_INPUT_ACTION_ID = "p0_allow_modal_input";

export const STANDING_ACCESS_START_DATE_BLOCK_ID =
  "standing_access_start_date_block";
export const STANDING_ACCESS_END_DATE_BLOCK_ID =
  "standing_access_end_date_block";
export const STANDING_ACCESS_START_TIME_BLOCK_ID =
  "standing_access_start_time_block";
export const STANDING_ACCESS_END_TIME_BLOCK_ID =
  "standing_access_end_time_block";
export const TIMEZONE_BLOCK_ID = "tz_block";

/** Characters a user must type before a notifier requests options for a select.
 *
 * Shared so Slack's `min_query_length` and the web modal's search threshold
 * cannot drift apart -- each option lookup is an uncached lister call.
 */
export const MIN_SELECT_QUERY_LENGTH = 2;

// Generic UI blocks
export const ERROR_BLOCK_ID = "p0_error";
export const RENDERED_REASON_BLOCK_ID = "p0_reason";
export const REASON_BLOCK_ID = "reason_input_block";
export const REQUEST_TIME_BLOCK_ID = "requested_duration_input_block";

// STANDING_ACCESS_START_BLOCK_ID and STANDING_ACCESS_END_BLOCK_ID are not actual Slack blocks. They
// are used as derived IDs for the start and end times for standing access based on the
// time selector + date selector + time zone selector
export const STANDING_ACCESS_START_BLOCK_ID = "standing_access_start_block";
export const STANDING_ACCESS_END_BLOCK_ID = "standing_access_end_block";
export const STANDING_ACCESS_PRINCIPAL_BLOCK_ID =
  "standing_access_principal_block";
export const STANDING_ACCESS_WATCHER_BLOCK_ID = "standing_access_watcher_block";

// Approval UI blocks
export const APPROVAL_BLOCK_ID = "p0_approval_block";
export const EXPIRY_ACTION_ID = "expiry";

export const CUSTOM_EXPIRY_BLOCK_ID = "custom_expiration_block";
export const CUSTOM_EXPIRY_INPUT_ACTION_ID = "custom_expiration_input_action";

export const REQUEST_AGAIN_REASON_ID = "request_again_reason";
export const REQUEST_AGAIN_REASON_INPUT_ID = "request_again_reason_input";

export const REQUEST_ARG_BLOCK_IDS = {
  reason: REASON_BLOCK_ID,
  duration: REQUEST_TIME_BLOCK_ID,
} as const;

export const ALLOW_ARG_BLOCK_IDS = {
  to: STANDING_ACCESS_PRINCIPAL_BLOCK_ID,
  watcher: STANDING_ACCESS_WATCHER_BLOCK_ID,
  start: STANDING_ACCESS_START_BLOCK_ID,
  end: STANDING_ACCESS_END_BLOCK_ID,
  ...REQUEST_ARG_BLOCK_IDS,
} as const;

/** Emoji used in rendered request notifications across every notifier. */
export enum Emoji {
  ArrowUp = "⬆️",
  CheckMark = "✅",
  HeavyExclamationMark = "❗",
  CrossMark = "❌",
  Eject = "⏏️",
  Stopwatch = "⏱️",
  HourglassWithFlowingSand = "⏳",
  HourglassDone = "⌛",
  GreyQuestionMark = "❔",
  CounterClockwiseArrows = "🔄",
}
